import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useSelectStructure } from './useSelectStructure';
import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { selectedAssemblyTemplateId as selectedAssemblyTemplateIdAtom } from '@/components/Analysis/state';

export const StructureSelector = () => {
  const [selectedAssemblyTemplateId, setSelectedAssemblyTemplateId] = useAtom(
    selectedAssemblyTemplateIdAtom
  );
  const { data, loading, error } = useSelectStructure();

  useEffect(() => {
    if (!loading && !error && data?.allTemplates?.length && !selectedAssemblyTemplateId) {
      const first = data.allTemplates[0];
      setSelectedAssemblyTemplateId(first?.id);
    }
  }, [data, error, loading, selectedAssemblyTemplateId, setSelectedAssemblyTemplateId]);

  if (loading) return <>...</>;
  if (error) return <>Error</>;

  const templates = data?.allTemplates;

  if (!templates?.length) return <>No templates found</>;

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedAssemblyTemplateId(event.target.value);
  };

  return (
    <FormControl fullWidth>
      <Select
        value={selectedAssemblyTemplateId || ''}
        label="Structure"
        onChange={handleChange}
        sx={{
          color: 'white',
          '& .MuiSelect-select': {
            padding: 1,
          },
        }}
      >
        {templates.map((template) => (
          <MenuItem key={template.id} value={template.id}>
            {template.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
